<template>
  <div class="d-flex align-items-center flex-column">
    <div class="card px-6 py-4 my-4 w-100 mw-650px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="'/inventory/import'">Phiếu nhập hàng</el-breadcrumb-item>
        <el-breadcrumb-item>{{ isCreate ? 'Tạo phiếu nhập hàng' : 'Chi tiết phiếu nhập hàng' }}</el-breadcrumb-item>
      </el-breadcrumb>
      <h4 class="mt-3">{{ isCreate ? 'Tạo phiếu nhập hàng' : 'Chi tiết phiếu nhập hàng' }}</h4>
    </div>
    <div class="card px-6 py-4 my-4 w-100 mw-650px">
      <h5>Thông tin cơ bản</h5>

      <div class="mt-3">
        <el-form
          :model="importForm"
          :rules="importFormRules"
          ref="validateForm"
          label-width="150px"
          class="demo-ruleForm flex-column"
          
        >
          <el-form-item label="Mã phiếu nhập" prop="cCode">
            <el-input
              v-model="importForm.cCode"
              :readonly="importForm.nTrangThai !== 0"
            />
          </el-form-item>
          <el-form-item label="Tên phiếu nhập" prop="cTenPhieuNhap">
            <el-input
              v-model="importForm.cTenPhieuNhap"
              :readonly="importForm.nTrangThai !== 0"
            />
          </el-form-item>
          <el-form-item label="Ghi chú" prop="cGhiChu">
            <el-input
              type="textarea"
              :rows="3"
              v-model="importForm.cGhiChu"
              :readonly="importForm.nTrangThai !== 0"
            />
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="card px-6 py-4 my-4 w-100 mw-650px">
      <h5>Sản phẩm</h5>
      <div>
        <el-autocomplete
          size="medium"
          style="margin-bottom: 20px; width: 100%"
          :fetch-suggestions="querySearch"
          v-model="searchProduct"
          @select="handleSelectSuggestionProduct"
          placeholder="Nhập tên sản phẩm"
          v-if="importForm.nTrangThai === 0"
        >
          <i
            class="el-icon-search el-input__icon"
            slot="suffix"
          />
          <template slot-scope="{ item }">
            <div style="display: flex; gap: 10px; padding: 5px">
              <el-image
                style="width: 50px; height: 50px"
                :src="baseUrl + '/product/img/' + item.odooImage1920"
                :fit="'fill'"
              />
              <span>{{ item.odooName }}</span>
            </div>
          </template>
        </el-autocomplete>

<!--        <el-button :size="'mini'"></el-button>-->
      </div>


      <el-table
        :data="listDetailImportForm"
        header-row-class-name="thead-light"
        :border="true"
        
        fit
      >
        <el-table-column prop="odooName" label="Sản phẩm" >
          <template #default="scope">
            <div style="display: flex; gap: 10px">
              <el-image
                style="width: 50px; height: 50px"
                :src="baseUrl + '/product/img/' + scope.row.odooImage1920"
                :fit="'fill'"
              />
              <span>{{ scope.row.odooName }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Tồn kho" prop="tonKho" width="100" align="center" v-if="isCreate" />

        <el-table-column label="Số lượng" width="180" align="center" prop="nSoLuong">
          <template #default="scope">
            <el-input-number
              v-model="scope.row.nSoLuong"
              :min="1"
              size="'mini'"
              style="width: 100%"
              v-if="importForm.nTrangThai === 0"
            />
            <span v-else>{{scope.row.nSoLuong}}</span>
          </template>
        </el-table-column>
        <el-table-column width="50" align="center" v-if="importForm.nTrangThai === 0">
          <template #default="scope">
            <i class="el-icon-delete" style="color: red; cursor: pointer" @click="handleDelete(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="card px-6 py-4 my-4 w-100 mw-650px  d-flex align-items-center justify-content-end flex-row " style="text-align: right">
      <el-button
        outline
        type="secondary"
        :disabled="isLoading"
        @click="$router.push({name: 'Import'})"
      >
        Thoát
      </el-button>
      <el-button
        type="primary"
        @click="handleAddNew"
        v-if="importForm.nTrangThai === 0"
        :disabled="isLoading"
      >
        Lưu
      </el-button>
    </div>


<!--    <modal-->
<!--      :show.sync="dialogSelectProduct"-->
<!--      dataBackDrop="static"-->
<!--      size="lg"-->
<!--    >-->
<!--      <h6 slot="header" class="modal-title">-->
<!--        Chọn sản phẩm-->
<!--      </h6>-->

<!--      <el-input-->
<!--        size="medium"-->
<!--        style="margin-bottom: 20px"-->
<!--      >-->
<!--        <i-->
<!--          class="el-icon-search el-input__icon"-->
<!--          slot="suffix"-->
<!--        />-->
<!--      </el-input>-->
<!--      <el-table-->
<!--        :data="tableData.content"-->
<!--        :border="true"-->
<!--        style="width: 100%"-->
<!--        class="tableSelectProduct"-->
<!--        @selection-change="handleSelectionChange"-->
<!--      >-->
<!--        <el-table-column-->
<!--          type="selection"-->
<!--        >-->
<!--        </el-table-column>-->
<!--        <el-table-column prop="odooName" label="Sản phẩm" >-->
<!--          <template #default="scope">-->
<!--            <div style="display: flex; gap: 10px">-->
<!--              <el-image-->
<!--                style="width: 50px; height: 50px"-->
<!--                :src="baseUrl + '/product/img/' + scope.row.odooImage1920"-->
<!--                :fit="'fill'"-->
<!--              />-->

<!--              <span>{{ scope.row.odooName }}</span>-->
<!--            </div>-->

<!--          </template>-->
<!--        </el-table-column>-->
<!--      </el-table>-->
<!--      <div class="col-12 py-2 pagination" style="justify-content: end">-->
<!--        <el-pagination-->
<!--          @size-change="handleSizeChange"-->
<!--          @current-change="handleCurrentChange"-->
<!--          :current-page.sync="tableData.pageNum"-->
<!--          :page-sizes="[5, 10]"-->
<!--          :page-size="tableData.pageSize"-->
<!--          layout="total, sizes, prev, pager, next"-->
<!--          :total="tableData.totalSize"-->
<!--        >-->
<!--        </el-pagination>-->
<!--      </div>-->
<!--      <template slot="footer">-->
<!--        <el-button-->
<!--          type="primary"-->
<!--          @click="handleSelectProduct"-->
<!--        >-->
<!--          Lưu-->
<!--        </el-button>-->
<!--        <el-button-->
<!--          outline-->
<!--          type="danger"-->
<!--        >-->
<!--          Thoát-->
<!--        </el-button>-->
<!--      </template>-->

<!--    </el-dialog>-->


  </div>
</template>
<script>
import { Inventory, Product } from "@/store/enums/StoreEnums";
import {baseUrl} from "@/utils/global"
import { useStore } from "vuex";
import { ElMessage } from "element-plus";
const oImportForm = {
  cCode: "",
  cTenPhieuNhap: "",
  cGhiChu: "",
  nTrangThai: 0
}

const oDetailImportForm = {
  nMaSanPham: "",
  nSoLuong: 0,
}

export default {
  data() {
    return {
      store:useStore(),
      baseUrl: baseUrl,
      //
      importForm: Object.assign({}, oImportForm),
      importFormRules: {
        cTenPhieuNhap: [
          { required: true, message: "Vui lòng nhập tên phiếu nhập", trigger: "blur" },
        ],
      },
      //
      detailImportForm: Object.assign({}, oDetailImportForm),
      listDetailImportForm: [],
      tempListDetailImportForm: [],
      //
      dialogSelectProduct: false,
      pageRequest: { pageNum: 1, pageSize: 5 },
      tableData: [],
      searchProduct: "",
      isLoading: false,
      //
      isCreate: true,
      importId: 0,

    }
  },
  methods: {
    querySearch(queryString, cb) {
      let tempData = this.tableData
      let results = queryString ? tempData.filter(this.createFilter(queryString)) : tempData;
      // // call callback function to return suggestion objects
      cb(results);
    },
    createFilter(queryString) {
      return (data) => {
        return (data.odooName.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    async getListProduct() {
      const res = await this.store.dispatch(Product.showProduct)
      if(res.code === 200) {
        this.tableData = res.data

        if(!this.isCreate && this.listDetailImportForm.length > 0) {
          this.tableData = this.tableData.filter(item => {
            return !this.listDetailImportForm.some(removeItem => {
              return item.nMaSanPham === removeItem.nMaSanPham;
            });
          });
        }
      }
    },

    handleSelectSuggestionProduct(item) {
      item.tonKho = item.nSoLuong
      item.nSoLuong = 1
      this.tableData =  this.tableData.filter(e => e.nMaSanPham !== item.nMaSanPham)
      this.listDetailImportForm.push(item)
    },

    handleAddNew() {
      this.$refs.validateForm.validate(async (valid) => {
        if (valid) {
          this.isLoading = true
          this.importForm.sysChiTietPhieuNhapList = this.listDetailImportForm

          if(this.isCreate) {
            const res = await this.store.dispatch(Inventory.newImport,this.importForm)
            if(res.code === 200) {
              ElMessage({ message: "Thêm mới thành công", type: "success" })
              this.$router.push({name: 'Import'})
            }
          } else {
            const res = await this.store.dispatch(Inventory.updateImport,this.importForm)
            if(res.code === 200) {
              await this.findImportById()
              ElMessage({ message: "Chỉnh sửa thành công", type: "success" })
              this.isLoading = false
            }
          }

        }
      })

    },
    handleDelete(item) {
      this.listDetailImportForm = this.listDetailImportForm.filter(e => e.nMaSanPham !== item.nMaSanPham)
      this.tableData.push(item)
    },

    async findImportById() {
      const res = await this.store.dispatch(Inventory.findImportById,this.importId)
      if(res.code === 200) {
        this.importForm = res.data
        this.listDetailImportForm = res.data.sysChiTietPhieuNhapList
      }
    },
  },
  async mounted() {
    if(this.$route.params.id) {
      this.importId = this.$route.params.id
      this.isCreate = false
      await this.findImportById()
    }
    await this.getListProduct()
  }
}
</script>
<style>
  .container .card px-6 py-4 my-4 w-100 mw-650px {
    background-color: white;
    width: 80%;
    margin: auto;
    padding: 20px;
    box-shadow: 1px 1px 5px 0px #ccc;
    border-radius: 5px;
    margin-bottom: 20px;
  }

  .tableSelectProduct .el-table-column--selection .cell {
    min-width: 48px !important;
  }
</style>
